import StepCounter from './StepCounter'

export default StepCounter



// WEBPACK FOOTER //
// ./src/app/elements/StepCounter/index.js